var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiskscore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "finance and payment/outline/shield"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2159",
    d: "M6 7.99999L6.91949 8.73558C7.33737 9.06988 7.94437 9.01595 8.29676 8.61322L10 6.66666",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 97",
    d: "M6.37545 2.05537L4.37762 2.94329C2.932 3.58579 1.95488 5.02557 2.11477 6.59944C2.4435 9.83535 3.52537 11.5339 5.95648 13.3155C7.16881 14.2039 8.83274 14.2061 10.0429 13.3148C12.4733 11.5247 13.5264 9.81241 13.8676 6.62087C14.037 5.0369 13.0583 3.58146 11.6026 2.93448L9.62455 2.05537C8.59029 1.5957 7.40971 1.5957 6.37545 2.05537Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskscore);
export default __webpack_public_path__ + "static/media/riskscore.fcdb3a911ffbd6aff5e41f2cac0af469.svg";
export { ForwardRef as ReactComponent };